'use strict';

import request from 'superagent';
import config from 'config';
import invariant from 'react/lib/invariant';
import normalizeError from '../utils/normalizeError';
import { decamelizeKeys } from 'humps';
import isFunction from 'lodash/lang/isFunction';

function ajax(req, data, callback, args) {
  if (isFunction(data)) {
    args = [callback].concat(args);
    callback = data;
    data = null;
  }

  invariant(isFunction(callback), 'Callback is required and must be a function.');

  if (data) {
    req = req
      .send(decamelizeKeys(data));
  }

  req
    .set('Accept', 'text/plain;application/json')
    .set('X-Auth-Token', config.localDevelopmentAPIToken).end((err, res) => {
    let body;

    if (res && res.ok) {
      body = res.body;
    } else if (!err) {
      err = normalizeError(res);
    }

    callback.apply(null, [err, body].concat(args));
  });
}

const APIUtils = {
  get(url, callback, ...args) {
    ajax(request.get(url), null, callback, args);
  },

  post(url, data, callback, ...args) {
    ajax(request.post(url), data, callback, args);
  },

  put(url, data, callback, ...args) {
    ajax(request.put(url), data, callback, args);
  },

  patch(url, data, callback, ...args) {
    ajax(request.patch(url), data, callback, args);
  },

  del(url, data, callback, ...args) {
    ajax(request.del(url), data, callback, args);
  }
};

export default APIUtils;



/** WEBPACK FOOTER **
 ** ./utils/APIUtils.js
 **/